
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dj-equipment-rental",
      function () {
        return require("private-next-pages/dj-equipment-rental.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dj-equipment-rental"])
      });
    }
  